// Time periods that carry the annual deductible total (same set as usp_PopulateEligibilityBenefitsDetails).
const TOTAL_PERIODS = ['', 'Calendar Year', 'Service Year', 'Episode'];

// PLWebApi sends the X12 coverage level code (IND, FAM, …) in coverageLevelDescription.
const COVERAGE_LEVELS = {
  CHD: 'Children Only',
  DEP: 'Dependents Only',
  ECH: 'Employee and Children',
  EMP: 'Employee Only',
  ESP: 'Employee and Spouse',
  FAM: 'Family',
  IND: 'Individual',
  SPC: 'Spouse and Children',
  SPO: 'Spouse Only',
};

const insuranceLabel = ebi => {
  if (!ebi.insuranceTypeDescription) {
    return '';
  }
  if (ebi.insuranceType === 'MA') {
    return 'Part A';
  }
  if (ebi.insuranceType === 'MB') {
    return 'Part B';
  }
  return ebi.insuranceTypeDescription;
};

const descending = (a, b) => (a > b ? -1 : a < b ? 1 : 0);

/**
 * Pairs each health-plan (service type 30) deductible's total with its remaining amount,
 * one entry per insurance type + coverage level (Individual/Family) + network.
 */
export function buildDeductibles(benefitInfoes) {
  const byKey = new Map();
  (benefitInfoes || []).forEach(ebi => {
    if (ebi.infoType !== 'C' || !(ebi.serviceTypeCodes || []).includes('30')) {
      return;
    }
    const period = ebi.timePeriod || '';
    const bucket =
      period === 'Remaining' ? 'remaining' : TOTAL_PERIODS.includes(period) ? 'total' : null;
    if (!bucket || ebi.amount === null || ebi.amount === undefined) {
      return;
    }

    const insurance = insuranceLabel(ebi);
    const coverageLevel = ebi.coverageLevelDescription || '';
    const key = [insurance, coverageLevel, ebi.inPlanNetwork].join('|');
    if (!byKey.has(key)) {
      byKey.set(key, {
        id: ebi.eligibilityBenefitInfoId,
        // insurance + coverage level with no separator: getCompanyStatuses matches 'Part A'/'Part B' on it
        description: insurance + coverageLevel,
        label: [insurance, COVERAGE_LEVELS[coverageLevel] || coverageLevel].filter(Boolean).join(' '),
        inPlanNetwork: ebi.inPlanNetwork,
        total: null,
        remaining: null,
      });
    }
    const deductible = byKey.get(key);
    if (deductible[bucket] === null) {
      deductible[bucket] = '$' + ebi.amount;
    }
  });

  return [...byKey.values()].sort(
    (x, y) =>
      descending(x.description, y.description) ||
      descending(x.inPlanNetwork || '', y.inPlanNetwork || '')
  );
}
